
// PriceContainer.js
import React, { useEffect, useState } from "react";
import { ChallengeSelect } from "./ChallengeSelect";
import { ChallengeCard } from "./ChallengeCard";
import { useChallenge } from "../../../context/ChallengeContext";
import { useNavigate } from "react-router-dom";
import TableLoading from "../../../Components/Loader/TableLoading";
import { API_BASE_URL } from "../../../config/api";

const title = "چالش ایده‌آل خود را پیدا کنید";
const subtitle = "";

function ChallengeContainer() {
  const navigate = useNavigate();
  const { challengePlans, defaultPlanName, plans, isLoading, error } =
    useChallenge();
  const [selectedPlan, setSelectedPlan] = useState(defaultPlanName);

  useEffect(() => {
    if (!selectedPlan && defaultPlanName) {
      setSelectedPlan(defaultPlanName);
    }
  }, [defaultPlanName, selectedPlan]);

  const fallbackPlan = plans[0];
  const activePlan =
    challengePlans[selectedPlan] ??
    challengePlans[defaultPlanName] ??
    fallbackPlan;

  const handlePlanSelect = (planName) => {
    if (planName && challengePlans[planName]) {
      setSelectedPlan(planName);
    }
  };
  const [loading, setLoading] = useState(true);
  const [accountData, setAccountData] = useState(null);
  const fetchAccountData = async () => {
    try {
      let response = await fetch(
        `${API_BASE_URL}challenges/trader/accounts`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
        },
      );

      // 401 → try refresh
      if (response.status === 401) {
        try {
          const refreshResponse = await fetch(
            `${API_BASE_URL}auth/trader/jwt/refresh/`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                refresh: localStorage.getItem("refresh"),
              }),
            },
          );

          if (!refreshResponse.ok) {
            // refresh failed → logout and redirect
            localStorage.removeItem("access");
            localStorage.removeItem("authCredentials");
            localStorage.removeItem("refresh");
            localStorage.removeItem("role");
            localStorage.removeItem("email");
            navigate("/signin");
            return;
          }

          const refreshData = await refreshResponse.json();
          localStorage.setItem("access", refreshData.access);

          // retry original request with new token
          response = await fetch(
            `${API_BASE_URL}challenges/trader/accounts`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("access")}`,
              },
            },
          );
        } catch (err) {
          console.error("Error refreshing token:", err);
          return;
        }
      }

      // final check
      if (!response.ok) {
        throw new Error(`https error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Account Data:", data);
      setAccountData(data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching account data:", error);
    }
  };

  useEffect(() => {
    fetchAccountData();
  }, []);

  if (isLoading && !activePlan) {
    return (
      <div className="w-full h-full flex justify-center items-center gap-2 text-zi-text-light dark:text-zi-text-dark">
        در حال دریافت اطلاعات
        <TableLoading />
      </div>
    );
  }

  if (error && !activePlan) {
    return (
      <section className="text-[#fafafa] min-h-fit w-full overflow-x-hidden">
        <div className="w-full max-w-5xl mx-auto flex flex-col items-center">
          <p className="text-sm text-amber-400">
            دریافت اطلاعات چالش ناموفق بود.
          </p>
        </div>
      </section>
    );
  }

  if (!activePlan) {
    return null;
  }

  if (loading) {
    return (
      <div className="w-full h-full flex justify-center items-center gap-2 text-zi-text-light dark:text-zi-text-dark">
        در حال دریافت اطلاعات
        <TableLoading />
      </div>
    );
  }

  if (
    accountData &&
    accountData?.live?.filter((acc) => acc.challenge_type === "real")?.length >=
      2
  ) {
    return (
      <div className="w-full h-full flex justify-center items-center gap-2 text-zi-text-light dark:text-zi-text-dark">
        همزمان حداکثر دو چالش فعال می توان داشت
      </div>
    );
  }

  return (
    <section className="bg-zi-bg1-dark text-[#fafafa] min-h-fit w-full overflow-x-hidden">
      <div className="w-full max-w-5xl mx-auto flex flex-col items-center">
        <div>
          <div className="w-full mx-auto text-center">
            <h1 className="text-2xl sm:text-4xl font-medium bg-clip-text text-transparent bg-gradient-to-r from-blue-400 via-cyan-300 to-white pb-2.5">
              {title}
            </h1>
            <p className="text-base md:text-lg text-[#fafafa]/80 mx-auto">
              {subtitle}
            </p>
          </div>
        </div>
        <ChallengeSelect
          plans={plans}
          onPlanSelect={handlePlanSelect}
          selectedPlan={activePlan.planName}
        />
        <div className="card-divider w-full my-3 sm:my-5 h-px bg-[linear-gradient(90deg,transparent,rgba(255,255,255,0.09)_20%,rgba(255,255,255,0.22)_50%,rgba(255,255,255,0.09)_80%,transparent)]" />
        <ChallengeCard plan={activePlan} />
      </div>
    </section>
  );
}

export { ChallengeContainer };
